<div>
    <input [disabled]="disabled" type="file" style="visibility: hidden" [accept]="accept" [multiple]="multiple"
        #fileSelector (change)="uploadListener($event)">

    <div (click)="fileSelector.click()" class="upload-file-cover">
        <ig-field></ig-field>
        <ig-button [disabled]="disabled" [size]="'md'" (trigger)="fileSelector.click()">select</ig-button>
    </div>
</div>


// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/common/components/file.selector/file.selector.component.html